var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticStyle:{"position":"fixed","bottom":"0px"},attrs:{"tile":""},model:{value:(_vm.pannelIndex),callback:function ($$v) {_vm.pannelIndex=$$v},expression:"pannelIndex"}})
}
var staticRenderFns = []

export { render, staticRenderFns }